import { notifications } from '@mantine/notifications';
import { IconMoodPuzzled } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { isNetworkError } from '@xver/libs/connectionNotifier';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const CONTAINER_COST_QUERY_KEY = 'apis.v1.containers.cost';

export function useContainerCostQuery(containerId: string | undefined) {
    const { t } = useTranslation('containerEngineInstance');
    const hasShownError = useRef(false);

    const query = useQuery({
        queryKey: [CONTAINER_COST_QUERY_KEY, containerId],
        queryFn: async () => Endpoints.v1.Containers.getContainerCost(containerId as string),
        enabled: !!containerId,
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        refetchInterval: 60_000,
    });

    const { data, isPending, error, refetch } = query;

    useEffect(() => {
        if (error && !isNetworkError(error) && !hasShownError.current) {
            hasShownError.current = true;
            notifications.show({
                title: t('cost.queryFailedTitle'),
                message: t('cost.queryFailedMessage'),
                icon: <IconMoodPuzzled size={32} color={'#eb5757'} />,
            });
        }

        if (!error) {
            hasShownError.current = false;
        }
    }, [error, t]);

    return { data, isPending, refetch };
}
